module.exports = __webpack_public_path__ + "img/logo.fd5f28ed.png";